// extracted by mini-css-extract-plugin
export var content = "_b9-3";
export var list = "_b9-4";
export var settingsContent = "_b9-7";
export var settingsPanel = "_b9-8";
export var state = "_b9-6";
export var triggerBadge = "_b9-2";
export var triggerButton = "_b9-1";
export var triggerShell = "_b9-0";
export var unreadDot = "_b9-5";